var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    rx: 3,
    fill: "#888FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 49L44.4243 32.4651L59.8609 49H29ZM54.8087 40.4548L58.9235 36.0462L71 49H62.7948L54.8087 40.4548ZM52.7148 26C54.6626 26 56.233 27.5247 56.233 29.4157C56.233 31.3068 54.6626 32.8314 52.7148 32.8314C50.7791 32.8314 49.1965 31.3068 49.1965 29.4157C49.1965 27.5247 50.7791 26 52.7148 26Z",
    fill: "#CDD1DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePreview);
export default __webpack_public_path__ + "static/media/image-preview.a0b70d4f5a605f3f53c3c5dcfdebf3c5.svg";
export { ForwardRef as ReactComponent };